import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Layout from './ui/pages/Layout';
import Invoice from './ui/pages/Invoice';
import './Global.css'; // Import your global CSS file
import InvoiceHistory from './ui/pages/InvoiceHistory';
import Vendor from './ui/pages/Vendor';
import InvoiceDetail from './ui/pages/InvoiceDetail';
import Login from './ui/pages/Login';
import { useAuth } from './context/AuthContext'; // Import useAuth hook
import User from './ui/pages/User';
import FinancialControllers from './ui/pages/FinancialControllers';
import { Spin } from 'antd';

function App() {
  const { role, isAuthenticated, authLoading } = useAuth(); // Using useAuth hook to get context
  // console.log('isAuthenticated', isAuthenticated);

  if (authLoading) {
    return (
      <Spin
        size="large"
        style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}
      />
    );
  }

  return (
    <Router>
      {isAuthenticated ? (
        <Layout>
          <Routes>
            <Route path="/" element={role === 'Financial Controller' ? <InvoiceHistory /> : <Invoice />} />
            <Route path="/invoice-history" element={<InvoiceHistory />} />
            <Route path="/invoice-detail/:id" element={<InvoiceDetail />} />
            <Route path="/vendors" element={<Vendor />} />
            <Route path="/users" element={<User />} />
            <Route path="/financial-controllers" element={<FinancialControllers />} />
          </Routes>
        </Layout>
      ) : (
        <Login /> // Render Login component when user is not authenticated
      )}
    </Router>
  );
}

export default App;
